import { CoverageIdEnum, PolicyProductIdEnum } from 'outshared-lib';

export const coverageMergePriceOptionsConfig = {
    [PolicyProductIdEnum.Car]: [
        {
            match: [CoverageIdEnum.CarAllrisk],
            mergePriceIfMatch: [CoverageIdEnum.CarLegalLiability],
        },
        {
            match: [CoverageIdEnum.CarLimitedCascoExtra],
            mergePriceIfMatch: [CoverageIdEnum.CarLegalLiability],
        },
        {
            match: [CoverageIdEnum.CarLimitedCasco],
            mergePriceIfMatch: [CoverageIdEnum.CarLegalLiability],
        },
        {
            match: [CoverageIdEnum.CarRoadsideAssistanceEurope],
            mergePriceIfMatch: [CoverageIdEnum.CarRoadsideAssistanceNetherlands],
        },
    ],
    [PolicyProductIdEnum.Travel]: [
        {
            match: [CoverageIdEnum.TravelMedicalCostWorld],
            mergePriceIfMatch: [CoverageIdEnum.TravelMedicalCostEurope],
        },
    ],
    [PolicyProductIdEnum.Moped]: [
        {
            match: [CoverageIdEnum.MopedLimitedCasco],
            mergePriceIfMatch: [CoverageIdEnum.MopedLegalLiability],
        },
        {
            match: [CoverageIdEnum.MopedAllrisk],
            mergePriceIfMatch: [CoverageIdEnum.MopedLegalLiability],
        },
    ],
    [PolicyProductIdEnum.Motorcycle]: [
        {
            match: [CoverageIdEnum.MotorAllrisk],
            mergePriceIfMatch: [CoverageIdEnum.MotorLimitedCasco],
        },
    ],
};
